/* src/app/components/lead-details/communication-details/communication-details/communication-details.component.css */
/*# sourceMappingURL=communication-details.component-XYPQHQZ2.css.map */
